import React from 'react'
import './Menu.scss'

export default ({blocks, current}) => {
	return(
		<div className="Menu">
			<ul>
				{
					blocks.map((item, i) =>
						<li key={i}>
							<a className={current === i ? 'active' : ''} href={`#Block_${i}`}>
								{item.title}
							</a>
						</li>
					)
				}
			</ul>
		</div>
	)
}